/**
 * VapiTranscription - Transcription window component for VAPI voice AI agent.
 * Transparent placeholder for displaying transcript text.
 */
class VapiTranscription {

    constructor(options = {}) {
        this.width = options.width ?? 200;
        this.height = options.height ?? 80;
    }

    render() {
        const div = document.createElement('div');
        div.setAttribute('class', 'vrai-component-slot vrai-transcription-slot');
        div.setAttribute('data-vrai-component', 'transcription');
        div.style.pointerEvents = 'none';
        div.innerHTML = `
            <div class="vrai-component-content" style="position:absolute;inset:0;overflow:visible;background:transparent;">
                <div class="vrai-transcription-window subtitles empty"></div>
            </div>
        `;
        this._root = div;
        return div;
    }

    getContentElement() {
        return this._root?.querySelector('.vrai-component-content');
    }

    getWindowElement() {
        return this._root?.querySelector('.vrai-transcription-window');
    }

    /** Sync poster with mesh (like VRIframeAgentGhost.updatePoster). */
    updatePoster(posterObj, mesh) {
        if (!posterObj || !mesh) return;
        posterObj.position.copy(mesh.position);
        posterObj.quaternion.copy(mesh.quaternion);
        posterObj.rotation.copy(mesh.rotation);
        posterObj.scale.copy(mesh.scale);
    }
}

export { VapiTranscription };
